module.exports = {"131123100":"武强镇","131123101":"街关镇","131123102":"周窝镇","131123200":"豆村乡","131123201":"北代乡","131123202":"孙庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131123.json
// module id = 220
// module chunks = 0